import { makeStyles } from '@material-ui/core';
import { PropsWithChildren, useEffect } from 'react';
import Footer from './Footer';
import Header from './Header';
import palette from 'assets/themes/Houston/palette';
import BreadCrumb from './BreadCrumb';
import { useHistory } from 'react-router';
import { useAppSelector } from 'hooks/redux';
import MaintenceAlert from './MaintenceAlert';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    paddingTop: '55px',
    '& > div:first-child': {
      zIndex: 90,
    },
  },
  subHeader: {
    position: 'absolute',
    width: '100%',
    top: '55px',
  },
  page: {
    minHeight: 'calc(100vh - 105px)',
  },
  footer: {
    position: 'relative',
    width: '100%',
  },
}));

const Container = (props: PropsWithChildren<{ blankPage?: boolean }>) => {
  const classes = useStyles();
  const course = useAppSelector((store) => store.course);
  const history = useHistory();

  const getStyles = () => {
    return {
      background: palette.neutrals.black,
    };
  };

  const getDocumentTitle = () => {
    const { pathname } = history.location;

    if (pathname.startsWith('/curso') || pathname.startsWith('/aula')) {
      return course.title ?? '';
    }

    if (pathname.startsWith('/ajuda')) {
      return 'Ajuda';
    }

    if (pathname.startsWith('/notificacoes')) {
      return 'Notificações';
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.children]);

  if (props.blankPage) {
    return <div style={{ height: '100vh' }}>{props.children}</div>;
  }

  return (
    <div className={classes.container} style={getStyles()}>
      <MaintenceAlert />
      <Header documentTitle={getDocumentTitle()} />

      <div className={classes.subHeader}>
        <BreadCrumb />
      </div>
      <div className={classes.page}>{props.children}</div>
      <div className={classes.footer}>
        <Footer />
      </div>
    </div>
  );
};

export default Container;
